'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collection_Icon = function (_React$PureComponent) {
	_inherits(Collection_Icon, _React$PureComponent);

	function Collection_Icon() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Collection_Icon);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Collection_Icon.__proto__ || Object.getPrototypeOf(Collection_Icon)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {

			var options = _this.props.icon;
			options.user_id = iconPressConfig.user_id;

			_this.props.toggleSelected(options);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Collection_Icon, [{
		key: 'render',
		value: function render() {
			var _props$icon = this.props.icon,
			    icon = _props$icon.icon,
			    title = _props$icon.title,
			    preview_url = _props$icon.preview_url,
			    internal_id = _props$icon.internal_id;


			var imgPreview = _react2.default.createElement('img', { className: 'ip-icon', onError: function onError(e) {
					e.target.src = iconPressConfig.placeholderImg;
				}, src: preview_url });

			if (this.props.icon.type == 'local') {
				imgPreview = _react2.default.createElement(_SvgIcon2.default, { icon: iconPressConfig.plugin_url + preview_url, isCustom: true });
			}
			var titleClass = title ? 'ip-u-tooltip ' : '';
			var internalId = iconPressConfig.debug == 1 ? 'int-' + internal_id : '';

			return _react2.default.createElement(
				'div',
				{ className: 'ip-collectionIcon ' + titleClass + ' ' + this.props.className + ' ' + internalId + ' ' + (this.props.icon.is_premium ? 'is-premium' : ''), 'data-tooltip': title, onClick: this.handleClick },
				_react2.default.createElement(
					'div',
					{ className: 'ip-collectionIcon-inner' },
					imgPreview
				)
			);
		}
	}]);

	return Collection_Icon;
}(_react2.default.PureComponent);

exports.default = Collection_Icon;


//////////////////
// WEBPACK FOOTER
// ./src/components/Collection_Icon.js
// module id = 259
// module chunks = 0 1